<template>
  <path
    d="M12 10.9002C11.39 10.9002 10.9 11.3902 10.9 12.0002C10.9 12.6102 11.39 13.1002 12 13.1002C12.61 13.1002 13.1 12.6102 13.1 12.0002C13.1 11.3902 12.61 10.9002 12 10.9002ZM12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM14.19 14.1902L6 18.0002L9.81 9.81018L18 6.00018L14.19 14.1902Z"
  />
</template>
